import React from 'react'
import { AppFC } from 'types'
import {
  AppFieldWrapper,
  AppLabelWrapper,
  AppValueWrapper,
} from 'components/AppAccount/AppAccount.style'
import { AppCheckBox } from 'components/Common/AppFormFields/AppCheckBox/AppCheckBox.component'
import { AppToolTipIcon } from 'components/Common/AppToolTip/AppToolTipIcon'
import { AppToolTip } from 'components/Common/AppToolTip/AppToolTip.component'

interface IAppBusinessProfileCheckBoxField {
  label?: string
  checkboxLabel: string
  checkboxValue: boolean
  LabelIcon?: React.ComponentType
  toolTipText?: string
}
export const AppBusinessProfileCheckBoxField: AppFC<IAppBusinessProfileCheckBoxField> = ({
  label,
  checkboxLabel,
  checkboxValue,
  LabelIcon,
  toolTipText,
}) => {
  return (
    <AppFieldWrapper>
      <AppLabelWrapper>
        {LabelIcon && <LabelIcon />}
        {label && label}
        {toolTipText && (
          <AppToolTip name={'TextFieldToolTip'} text={toolTipText} variant="primary" place="bottom">
            <AppToolTipIcon />
          </AppToolTip>
        )}
      </AppLabelWrapper>
      <AppValueWrapper>
        <AppCheckBox label={checkboxLabel} value={checkboxValue} disabled={true}></AppCheckBox>
      </AppValueWrapper>
    </AppFieldWrapper>
  )
}
